// Direct connection to Binance public WebSocket data mirror.
// Symbol-scoped: pass the trading pair symbol (e.g. "BTCUSDT").
//
// Docs: https://binance-docs.github.io/apidocs/spot/en/

const wsUrlFor = (symbol) => {
  const s = String(symbol || "").toLowerCase();
  return `wss://data-stream.binance.vision:9443/stream?streams=${s}@depth20@100ms/${s}@trade`;
};

export class BinanceStream {
  constructor({ symbol, onDepth, onTrade, onStatus }) {
    this.symbol = symbol;
    this.onDepth = onDepth;
    this.onTrade = onTrade;
    this.onStatus = onStatus;
    this.ws = null;
    this.attempt = 0;
    this.closed = false;
    this.reconnectTimer = null;
  }

  connect() {
    if (this.closed) return;
    this.onStatus?.("connecting");
    try {
      this.ws = new WebSocket(wsUrlFor(this.symbol));
    } catch {
      this.scheduleReconnect();
      return;
    }

    this.ws.onopen = () => {
      this.attempt = 0;
      this.onStatus?.("open");
    };

    this.ws.onmessage = (evt) => {
      let payload;
      try {
        payload = JSON.parse(evt.data);
      } catch {
        return;
      }
      const stream = payload?.stream;
      const data = payload?.data;
      if (!stream || !data) return;

      if (stream.endsWith("@depth20@100ms")) {
        this.onDepth?.(data);
      } else if (stream.endsWith("@trade")) {
        this.onTrade?.(data);
      }
    };

    this.ws.onerror = () => {
      /* onclose will handle reconnect */
    };

    this.ws.onclose = () => {
      this.onStatus?.("closed");
      this.scheduleReconnect();
    };
  }

  scheduleReconnect() {
    if (this.closed) return;
    this.attempt += 1;
    const delay = Math.min(30000, 500 * Math.pow(2, this.attempt));
    this.onStatus?.("reconnecting");
    this.reconnectTimer = setTimeout(() => this.connect(), delay);
  }

  close() {
    this.closed = true;
    if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
    if (this.ws) {
      this.ws.onopen = null;
      this.ws.onmessage = null;
      this.ws.onerror = null;
      this.ws.onclose = null;
      try {
        this.ws.close();
      } catch {
        /* noop */
      }
    }
  }
}
